import { render, staticRenderFns } from "./APP.vue?vue&type=template&id=1e77e60a&scoped=true&"
import script from "./APP.vue?vue&type=script&lang=js&"
export * from "./APP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e77e60a",
  null
  
)

export default component.exports